import React from 'react';
import { createComponent } from '@lit/react';
import { IxSwitch as LitComp } from '../IxSwitch.js';

customElements.define('ix-switch', LitComp);

export const IxSwitch = createComponent({
  tagName: 'ix-switch-react',
  elementClass: LitComp,
  react: React,
});
